import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { DropdownMenu } from 'seagull';
import { ColorAnchor } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useClientView } from '~/hooks/useClientView';
import { useLocaleKeys } from '~/i18n';
export const GetClientViewMenuItemTID = (parentTestId)=>getTestIds(parentTestId);
export default function ClientViewMenuItem(param) {
    let { clientBusinessId, viewUserId, disabled, disabledTooltip, testId } = param;
    const { t: clientViewTexts } = useLocaleKeys('components.clientView');
    const { startClientView } = useClientView();
    const { ClientViewMenuItemTestIds } = useMemo(()=>GetClientViewMenuItemTID(testId), [
        testId
    ]);
    const isDisabled = disabled || clientBusinessId == null;
    return /*#__PURE__*/ _jsx(DropdownMenu.Item, {
        iconStart: /*#__PURE__*/ _jsx(ColorAnchor, {
            size: 20
        }),
        onClick: ()=>{
            if (clientBusinessId != null) {
                startClientView(clientBusinessId, viewUserId);
            }
        },
        disabled: isDisabled,
        tooltipProps: isDisabled && disabledTooltip != null ? {
            title: disabledTooltip,
            placement: 'top'
        } : undefined,
        testId: ClientViewMenuItemTestIds.Root(),
        bi: {
            name: 'view-client-portal-menu-item'
        },
        children: clientViewTexts.menuItem()
    });
}
